import React        from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ROLE_LOADER_CONFIG } from "./roleConfig";
import WordMark from "../WordMark";

const AuthLoader = ({ role = null }) => {
  const theme  = useTheme();
  const t      = theme.custom;                                         // your token map

  const cfg    = ROLE_LOADER_CONFIG[role] ?? ROLE_LOADER_CONFIG.DEFAULT;
  const color  = t[cfg.colorToken];                                    // e.g. t.steel / t.accent
  const color2 = t[cfg.color2Token];                                   // e.g. t.steel2 / t.accent2
  

  return (
    <Box
      sx={{
        minHeight:      "100vh",
        background:     t.bg,
        display:        "flex",
        flexDirection:  "column",
        alignItems:     "center",
        justifyContent: "center",
        gap:            "28px",
      }}
    >
      {/* Wordmark */}
      <WordMark size="36px" />

      {/* Spinner ring — top+right colored, rest transparent */}
      <Box
        sx={{
          width:            "52px",
          height:           "52px",
          borderRadius:     "50%",
          border:           "2.5px solid transparent",
          borderTopColor:   color,
          borderRightColor: color2,
          animation:        "psi360-spin 0.9s linear infinite",
          "@keyframes psi360-spin": {
            to: { transform: "rotate(360deg)" },
          },
        }}
      />

      {/* Role label + status message */}
      <Box sx={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "5px" }}>
        <Typography
          sx={{
            fontFamily:    "'Inter', 'Courier New', monospace",
            fontSize:      "11px",
            letterSpacing: "0.20em",
            textTransform: "uppercase",
            color:         color,
            fontWeight:    500,
          }}
        >
          {cfg.label}
        </Typography>
        <Typography
          sx={{
            fontFamily:    "'Inter', 'Courier New', monospace",
            fontSize:      "10px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color:         t.text3,                                    // muted hint color from your tokens
          }}
        >
          {cfg.message}
        </Typography>
      </Box>

      {/* Animated shimmer bar */}
      <Box
        sx={{
          width:        "180px",
          height:       "3px",
          borderRadius: "2px",
          overflow:     "hidden",
          background:   color2,                                        // soft fill from tokens
        }}
      >
        <Box
          sx={{
            height:       "100%",
            borderRadius: "2px",
            background:   color,
            animation:    "psi360-pulse 1.5s ease-in-out infinite",
            "@keyframes psi360-pulse": {
              "0%,100%": { width: "20%", marginLeft: "0%" },
              "50%":     { width: "55%", marginLeft: "22%" },
            },
          }}
        />
      </Box>

      {/* Bouncing dots */}
      <Box sx={{ display: "flex", gap: "8px" }}>
        {[0, 0.18, 0.36].map((delay, i) => (
          <Box
            key={i}
            sx={{
              width:        "7px",
              height:       "7px",
              borderRadius: "50%",
              background:   color,
              opacity:      0.45,
              animation:    `psi360-bounce 1.1s ease-in-out ${delay}s infinite`,
              "@keyframes psi360-bounce": {
                "0%,100%": { transform: "translateY(0)",     opacity: 0.45 },
                "50%":     { transform: "translateY(-10px)", opacity: 1    },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AuthLoader;